import { NgModule } from '@angular/core';
import {
  AppsSharedModule,
  BaseAdministrationModule,
  BaseDashboardModule,
  BaseSharedModule,
  BaseInquiryModule,
} from 'base';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerDashboardUnpublishedInquiriesComponent } from './_components/dashboard-unpublished-inquiries/base-customer-dashboard-unpublished-inquiries.component';
import { BaseCustomerDashboardOfferCardComponent } from './_components/dashboard-offer-card/base-customer-dashboard-offer-card.component';
import { BaseCustomerDashboardOperationsComponent } from './_components/dashboard-operations/base-customer-dashboard-operations.component';
import { BaseCustomerDashboardComponent } from './base-customer-dashboard.component';
import { BaseCustomerInquiryModule } from '../inquiry/inquiry.module';
import { BaseCustomerDashboardUnpublishedInquiriesListHeadlineComponent } from './_components/dashboard-unpublished-inquiries/dashboard-unpublished-inquiries-list-headline/dashboard-unpublished-inquiries-list-headline.component';
import { BaseCustomerDashboardUnpublishedInquiriesListItemComponent } from './_components/dashboard-unpublished-inquiries/dashboard-unpublished-inquiries-list-item/dashboard-unpublished-inquiries-list-item.component';

@NgModule({
  imports: [
    BaseSharedModule,
    AppsSharedModule,
    BaseDashboardModule,
    BaseAdministrationModule,
    BaseCustomerSharedModule,
    BaseCustomerInquiryModule,
    BaseInquiryModule,
  ],
  declarations: [
    BaseCustomerDashboardComponent,
    BaseCustomerDashboardOfferCardComponent,
    BaseCustomerDashboardOperationsComponent,
    BaseCustomerDashboardUnpublishedInquiriesComponent,
    BaseCustomerDashboardUnpublishedInquiriesListHeadlineComponent,
    BaseCustomerDashboardUnpublishedInquiriesListItemComponent,
  ],
  exports: [
    BaseCustomerDashboardComponent,
    BaseCustomerDashboardOfferCardComponent,
    BaseCustomerDashboardOperationsComponent,
    BaseCustomerDashboardUnpublishedInquiriesComponent,
    BaseCustomerDashboardUnpublishedInquiriesListHeadlineComponent,
    BaseCustomerDashboardUnpublishedInquiriesListItemComponent,
  ],
})
export class BaseCustomerDashboardModule {}
